import React from 'react';
import cn from 'clsx';
import { StyledUtpCardGrid, utpCardGridStylesMap } from './utp-card-grid-styles';
import { UtpCardGridProps } from './utp-card-grid-types';

export const UtpCardGrid: React.FC<UtpCardGridProps> = ({ cardNumber, children, className }) => (
  <StyledUtpCardGrid className={cn(utpCardGridStylesMap[cardNumber], className)} cardNumber={cardNumber}>
    {children}
  </StyledUtpCardGrid>
);
